import invalidate from '../../util/invalidate';
import mustRender from '../../util/mustRender';

function getExistingLayout(layout) {
  return layout === 'right' ? 'default' : layout;
}

function convertLegend(chart) {
  const { data, sizes } = chart;
  const { enabled, layout, showColorChips, itemsInOrder, fredSeries, blsSeries, type } = data;

  const crops = Object.keys(sizes);
  const { legend } = sizes[crops[0]];
  const legendLayout = layout || getExistingLayout(legend.layout);
  const legendEnabled = enabled !== undefined ? enabled : legend.enabled;

  const colorChipsVisible = showColorChips !== undefined ? showColorChips : true;
  const validChart =
    type === 'market' || (fredSeries && !!fredSeries.length) || (blsSeries && !!blsSeries.length);
  const legendItemsInOrder = itemsInOrder !== undefined ? itemsInOrder : validChart;

  return {
    enabled: legendEnabled,
    layout: legendLayout,
    showColorChips: colorChipsVisible,
    itemsInOrder: legendItemsInOrder,
  };
}

function fetchLegendInfo(state, action) {
  if (!action.data) {
    return state;
  }
  if (action.data.status === 'success') {
    return convertLegend(action.data.body.chart);
  }
  return state;
}

function updateChart(stateTree, state, payload, prop) {
  const { active } = stateTree.documents;

  let activeDoc = stateTree.documents.items[active];
  activeDoc = activeDoc.setIn(['chart', 'data', 'showTooltips'], false);
  activeDoc = invalidate(activeDoc, '*', 'chart/data');
  activeDoc = activeDoc.setIn(['mustRender'], mustRender(activeDoc));

  localStorage.setItem('saved', 'false');

  if (prop) {
    return {
      ...state,
      [prop]: payload,
      mustRender: activeDoc.mustRender,
    };
  }

  return state;
}

export { fetchLegendInfo, updateChart };
